import { render, staticRenderFns } from "./form-block.vue?vue&type=template&id=545e59fc&scoped=true"
import script from "./form-block.vue?vue&type=script&lang=js"
export * from "./form-block.vue?vue&type=script&lang=js"
import style0 from "./form-block.vue?vue&type=style&index=0&id=545e59fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545e59fc",
  null
  
)

export default component.exports